/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TokenAuthInputDto { 
    tenantId?: number | null;
    superAdmin?: boolean;
    admin?: boolean;
    code?: string | null;
    client?: boolean;
    redirectUrl?: string | null;
    refreshToken?: string | null;
}

